namespace app.support {
  export interface StfPlaceholderScope {
    stfPlaceholder: string;
    $watch: Function;
  }

  export class StfPlaceholder implements ng.IDirective {
    public scope: Object = {
      'stfPlaceholder': '='
    }

    public constructor() {

    }

    public link($scope: StfPlaceholderScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) {
      $scope.$watch('stfPlaceholder', (value) => {
        element.prop('placeholder', $scope.stfPlaceholder);
      });
    }

    public static factory(): ng.IDirectiveFactory {
      return () => {
        'ngInject';
        return new StfPlaceholder();
      }
    }
  }

  angular.module('app.support')
    .directive('stfPlaceholder', StfPlaceholder.factory());
}